import { UPDATE_USER_STATUS, UPDATE_USER_STATUS_SUCCESS, UPDATE_USER_STATUS_FAILURE } from "../../Action/actionTypes";

const INIT_STATE = {
  loading: false,
};

const updateUserStatusReducer = (state = INIT_STATE, action) => {
  switch (action.type) {
    case UPDATE_USER_STATUS:
      return { ...state, loading: true };
    case UPDATE_USER_STATUS_SUCCESS:
      return {
        ...state,
        loading: false,
      };
    case UPDATE_USER_STATUS_FAILURE:
      return { ...state, loading: false };
    default:
      return state;
  }
};

export default updateUserStatusReducer;
